import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const RadioUnchecked = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" sx={{ borderRadius: '50%', border: '1px solid currentColor' }} {...props}>
            <circle cx="12" cy="12" r="9.5" fill="transparent" />
        </SvgIcon>
    );
};

export default RadioUnchecked;
